import Toast from "helper/toast";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "./use-auth";

export default function useHttp(isLoading = true) {
  const [loading, setLoading] = useState(isLoading);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const navigate = useNavigate();
  const AuthCTX = useAuth();

  const request = useCallback(
    async ({ url, title, values, isFile, isMulty }) => {
      isFile && setUploadProgress(0);
      isFile && setIsUploading(true);
      !isMulty && setLoading(true);
      var res = await url(values);
      !isMulty && setLoading(false);
      isFile && setIsUploading(false);
      if (!res.ok) {
        if (res.status === 401) AuthCTX.logout();

        if (res.data?.code) {
          if (res.data?.code === 607) {
            Toast({
              type: "custom-warn",
              title: `حساب شما به دلیل ${res.data.block_reason} مسدود شده است`,
              autoClose: false,
            });
            AuthCTX.logout();
            return null;
          }
          switch (res.data.code) {
            // case 1:
            //     return Toast({ type: 'custom-warn', title: 'این کد برای حساب شما ثبت نشده است' })
            case 3:
              return Toast({ type: "login" });
            case 84:
              return Toast({
                type: "custom-err",
                title: "ایمیل وارد شده ثبت نام نشده است",
              });
            case 345:
              return Toast({
                type: "custom-warn",
                title: "دو دقیقه دیگر مجددا تلاش کنید",
              });
            case 533:
              return Toast({
                type: "custom-err",
                title: "هر پنج دقیقه یک بار امکان ارسال ایمیل وجود دارد",
              });
            case 534:
              return Toast({
                type: "custom-err",
                title: "توکن منقضی شده یا نامعتبر است",
              });
            case 600:
              return Toast({
                type: "custom-err",
                title: "کلمه عبور فعلی اشتباه میباشد",
              });
            case 1313:
              return Toast({
                type: "custom-err",
                title: "نام کاربری یا رمزعبور اشتباه است",
              });
            case 3333:
              return Toast({
                type: "custom-err",
                title: "نام کاربری یا رمزعبور اشتباه است",
              });
            default:
              return Toast({ type: "err", title });
          }
        } else {
          return Toast({ type: "err", title });
        }
      }

      return res.data;
    },
    []
  );

  return {
    request,
    loading,
    setLoading,
    uploadProgress,
    setUploadProgress,
    isUploading,
  };
}
